import classes from './AppHeader.module.css';

import NavigationBar from './NavigationBar';
import boarder from './images/header_boarder.png';
import logo from './images/logowhite_notagline.png';

function AppHeader() {

    const styles = `${classes.frame} ${classes.frame.static}`;

    return (
    <>
        <div className={styles}>
            <img className={classes.header_boarder} src={boarder} alt="header_boarder"/>
            <img className={classes.logo_white_no_tagline} src={logo} alt="logo" />
            <div className={classes.app_name}> EDISON-4.0&#8482;</div>
            <div className={classes.sub_app_name}> Experimental Planner</div>
        </div>
        <NavigationBar />
    </>
    );
}

export default AppHeader;
